import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from 'app/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'app/components/ui/table';
import { useDashboardSlice } from '../../slice';
import { useEffect } from 'react';
import { formatDistanceToNow } from 'date-fns';
import { Link } from 'react-router-dom';
import { PAYMENT_STATUS_DETAILS } from 'utils/constants';
import { ArrowRight, CreditCard } from 'lucide-react';
import { convertDateFormat } from 'utils/format-date';
export function RecentTransactions() {
  const { useGetRecentTransactionsQuery } = useDashboardSlice();
  const [getRecentTransactions, { data: recentTransactions }] =
    useGetRecentTransactionsQuery({});

  useEffect(() => {
    getRecentTransactions();
  }, []);

  return (
    <Card className="border-none bg-white  dark:bg-transparent rounded-2xl overflow-hidden">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 py-3 border-b border-gray-200 bg-[#0E7490] text-white">
        {' '}
        <CardTitle className="text-md font-medium flex items-center gap-2">
          <CreditCard className="w-4 h-4" />
          Recent Transactions
        </CardTitle>
        <Link
          to="/transactions"
          className="text-xs text-white hover:underline uppercase flex items-center gap-1"
        >
          View All <ArrowRight className="w-4 h-4" />
        </Link>
      </CardHeader>
      <CardContent className="mt-4 overflow-x-auto max-h-[530px] overflow-y-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="text-gray-500 text-xs uppercase whitespace-nowrap">
                Transaction ID
              </TableHead>
              <TableHead className="text-gray-500 text-xs uppercase whitespace-nowrap">
                Username
              </TableHead>
              <TableHead className="text-gray-500 text-xs uppercase">
                Total
              </TableHead>
              <TableHead className="text-gray-500 text-xs uppercase whitespace-nowrap">
                Payment Status
              </TableHead>
              <TableHead className="text-gray-500 text-xs uppercase whitespace-nowrap">
                Date
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {recentTransactions?.data?.length ? (
              recentTransactions.data.map(transaction => {
                const paymentStatus =
                  PAYMENT_STATUS_DETAILS[transaction.payment_status];

                return (
                  <TableRow
                    key={transaction.transaction_id}
                    className="hover:bg-gray-50"
                  >
                    <TableCell>{transaction.order_id}</TableCell>
                    <TableCell>{transaction?.username}</TableCell>
                    <TableCell className="whitespace-nowrap">
                      {transaction?.currency} {transaction?.amount}
                    </TableCell>
                    <TableCell>
                      {paymentStatus ? (
                        <span
                          className={`inline-flex items-center gap-1 rounded-full border px-3 py-1 text-xs font-medium shadow-sm ${paymentStatus.color}`}
                        >
                          {paymentStatus.label}
                        </span>
                      ) : (
                        <span className="text-xs text-gray-500">Unknown</span>
                      )}
                    </TableCell>
                    <TableCell className="whitespace-nowrap">
                      {convertDateFormat(transaction.created_at)}
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell
                  colSpan={6}
                  className="text-center text-gray-400 py-8"
                >
                  No recent orders found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
